import Rank from "components/icon/rank";
import TriviasIcon from "components/icon/trivias";
import Auctions from "components/icon/auctions";
import { Link } from "react-router-dom";
import { ButtonNavStyle } from "theme/home";
import useWhiteBg from "hooks/use-white-bg";
import Profile from "components/icon/profile";
import Raffles from "components/icon/raffles";
import CrowAguila from "components/icon/crow-aguila";
import Referrals from "components/icon/referrals";
import Collection from "components/icon/collection";
import Awards from "components/icon/awards";
import { TextHomeButton } from "views/home/style/text.style";
import Prizes from "components/icon/prizes";
import TriviasIconIndio from "components/icon/TriviasIndio";
import LineUpIndio from "components/icon/LineUpIndio";
import ProfileIndio from "components/icon/ProfileIndio";
import EagleTecate from "components/icon/eagle-tecate";
import textServices from "services/text-services";
import Photos from "components/icon/photos";
import UploadImage from "components/icon/upload-image";
import Paris from "components/icon/paris";

const Links = {
  "Gift": {
    icon: CrowAguila,
    text: "INGRESAR CÓDIGOS",
    link: "/redeem"
  },
  "Rank": {
    icon: Rank,
    text: "RANKING",
    link: "/ranking"
  },
  "Auctions": {
    icon: Auctions,
    text: "SUBASTAS",
    link: "/auctions"
  },
  "Profile": {
    icon: Profile,
    text: "MI PERFIL",
    link: "/profile/information"
  },
  "ProfileIndio": {
    icon: ProfileIndio,
    text: "MI PERFIL",
    link: "/profile/information"
  },
  "Raffles": {
    icon: Raffles,
    text: "PREMIO DIARIO",
    link: "/raffles"
  },
  "Referrals": {
    icon: Referrals,
    text: "REFERIR AMIGOS",
    link: "/referrals"
  },
  "Collections": {
    icon: Collection,
    text: textServices.findByText('home/sellos', 'MIS COLECCIONES'),
    link: "/collections"
  },
  "Awards": {
    icon: Awards,
    text: "MIS PREMIOS",
    link: "/prizes"
  },
  "Prizes": {
    icon: Prizes,
    text: "VITRINA DE PREMIOS",
    link: "/prizes"
  },
  "Trivias": {
    icon: TriviasIcon,
    text: "TRIVIAS",
    link: "/trivias"
  },
  "TriviasIndio": {
    icon: TriviasIconIndio,
    text: "MIS TRIVIAS",
    link: "/trivias"
  },
  "Photos": {
    icon: Photos,
    text: "SUS FOTOS",
    link: "/photographer/start?isYou=true"
  },
  "UploadImage": {
    icon: UploadImage,
    text: "SUBIR FOTO",
    link: "/photographer/upload"
  },

  // TODO: Cambiar url por la externa de indio
  "LineUp": {
    icon: LineUpIndio,
    text: "LINE UP",
    href: true,
    link: `${URL_BASE}/rockid/lineup`
  },
  "ProfileID": {
    icon: EagleTecate,
    text: "MI TECATE ID",
    link: "/profile/identificacion",
    type: 'full'
  },

  "TriviaMatchpaint": {
    icon: Paris,
    text: "VIAJE A PARÍS",
    link: "/trivias",
  }
}

function ButtonNav({ route }: any) {

  const shouldUseWhiteBg = useWhiteBg()
  const item = Links[route]

  if (item?.href) {
    return (
      <a className="w-1/3" href={item?.link} target="_blank" rel="noreferrer">
        <ButtonNavStyle shouldUseWhiteBg={shouldUseWhiteBg} className="flex flex-col items-center justify-center gap-2 py-3 px-2 h-24 text-center font-medium text-xs">
          <span className="w-full flex-1 flex items-center justify-center">
            <item.icon />
          </span>
          <TextHomeButton className="text-center font-medium text-xs saira leading-none">{item.text}</TextHomeButton>
        </ButtonNavStyle>
      </a>
    )
  }

  if (item.type === 'full') {
    return (
      <Link to={item.link} className="w-full">
        <ButtonNavStyle shouldUseWhiteBg={shouldUseWhiteBg} className={`flex items-center justify-evenly py-3 px-2 h-24 text-center font-medium text-xs`}>
          <TextHomeButton className="text-center font-medium text-xs saira leading-none">{item.text}</TextHomeButton>
          <span className=" flex items-center justify-center">
            <item.icon />
          </span>
        </ButtonNavStyle>
      </Link>
    )
  }

  return (
    <Link to={item.link} className={'w-1/3'}>
      <ButtonNavStyle shouldUseWhiteBg={shouldUseWhiteBg} className={`flex flex-col items-center justify-center py-3 px-2 h-24 text-center font-medium text-xs`}>
        <span className="w-full flex-1 flex items-center justify-center">
          <item.icon />
        </span>
        <TextHomeButton className="text-center font-medium text-xs saira leading-none">{item.text}</TextHomeButton>
      </ButtonNavStyle>
    </Link>
  )
}

export default ButtonNav;